import Overlay from '../Overlay'
import React from 'react'
import styled from 'styled-components'
import LoadingImage from 'images/common/loading.svg'

export type LoadingOverlayProps = {
  isOpen: boolean
}

const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const LoadingSpinner = styled.img`
  height: 150px;
  width: 150px;
  animation: spin 1.5s linear infinite;

  @keyframes spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @media ${props => props.theme.media.md} {
    height: 200px;
    width: 200px;
  }
`

const LoadingText = styled.div`
  color: ${props => props.theme.members.colors.white};
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 1.5rem;

  @media ${props => props.theme.media.md} {
    font-size: 2rem;
    margin-top: 2rem;
  }
`

export const StyledLoadingOverlay: React.FC<LoadingOverlayProps> = (props: LoadingOverlayProps) => {
  return (
    <Overlay isOpen={props.isOpen}>
      <Loading>
        <LoadingSpinner src={LoadingImage} alt="loading" />
        <LoadingText>読み込み中...</LoadingText>
      </Loading>
    </Overlay>
  )
}

